module.exports = __webpack_public_path__ + "img/portraits_05_V.4ccdfc74.webp";